import React from 'react';
import PropTypes from 'prop-types';
import LinkTableCellComponent from "../common/LinkTableCellComponent";
import {TableCell} from "./CustomerTableRowComponent";
import styled from "@emotion/styled";


const Wrapper = styled.div`
  text-overflow: ellipsis;
  color: var(--color-blue-600),

`;

function ContractLinksTableCell({contracts, onClick}) {

    const getContractsLink = (contracts) => {
        let headings = "";
        for (let i = 0; i < contracts.length; i++) {
            if (i > 0) {
                let amountRemaining = contracts.length - 1;
                headings = `${headings} + ${amountRemaining} More`;
                break;
            }

            headings = `${headings} ${contracts[i].contractNumber}`;

            let moreItems = (contracts.length - 1) > i;
            if (moreItems) headings = headings + ","
        }

        return headings;
    };

    const contractsLink = getContractsLink(contracts);

    return (
        <Wrapper>
            {
                (contracts.length)
                    ? <LinkTableCellComponent name={contractsLink} onLinkClick={onClick}/>
                    : <TableCell key={4}>No Contract</TableCell>
            }
        </Wrapper>
    );
}

ContractLinksTableCell.propTypes = {};
ContractLinksTableCell.defaultProps = {
    contracts: []
};

export default ContractLinksTableCell;
